// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-gray-900{
    --tw-bg-opacity: 1 !important;
    background-color: rgb(21 25 30 / var(--tw-bg-opacity, 1)) !important
}`, "",{"version":3,"sources":["webpack://./src/components/index.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B;AACJ","sourcesContent":[".bg-gray-900{\n    --tw-bg-opacity: 1 !important;\n    background-color: rgb(21 25 30 / var(--tw-bg-opacity, 1)) !important\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
